import { Yup } from "components/DynamicForm/utils";
import { ADDRESS_SELECT_INPUT_TYPE } from "utils/Constants";

const form = {
    sections: [
        {
            title: "Direccion",
            fields: [
                [
                    {
                        "type": "text",
                        "name": "name",
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(),
                        "label": "Nombre Direccion"
                    },
                ],
                [
                    {
                        "type": ADDRESS_SELECT_INPUT_TYPE,
                        "name": "delivery",
                        "validation": Yup.string().required(),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "address",
                        "validation": Yup.string().required(),
                        "label": "Direccion Entrega"
                    },
                ],

            ]
        }
    ]
};

export default form;